import Vue from 'vue';
import Router from 'vue-router';

const Home = () => import('@/components/Home');
const ProjectList = () => import('@/components/ProjectList');
const About = () => import("@/components/About");
const SocialWorks = () => import("@/components/SocialWorks");

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/', name: 'Home', component: Home
    },
    {
      path: '/empresa',
      name: 'About',
      component: About
    },
    {
      path: '/projetos',
      name: 'ProjectList',
      component: ProjectList
    },
    {
      path: '/obra-social',
      name: 'SocialWorks',
      component: SocialWorks
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js